<template>
  <div class="activity-log-item">
    <el-form :model="form">
      <div class="activity-log-item__content-wrap">
        <div class="activity-log-item__status">
          <span><i :class="itemIcon"></i></span>
        </div>
        <div class="activity-log-item__content">
          <div class="activity-log-ite__time">{{data.entryDate | toDate('DD/MM/YYYY HH:mm')}}</div>
          <el-form-item
            class="material-style"
            :label="data.labelInput"
          >
            <el-input
              type="textarea"
              :value="form.description"
              disabled
            ></el-input>
          </el-form-item>
          <!-- SLOT -->
          <slot />
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'ActivityInfoLogItem',
  props: {
    data: { type: Object, required: true },
    formModel: { type: Function, required: true }
  },
  watch: {
    data: {
      immediate: true,
      handler (value) {
        this.form = this.copyObjectProps(this.formModel(), value)
      }
    }
  },
  data () {
    return {
      form: {}
    }
  },
  computed: {
    itemIcon () {
      return this.data.isEmployeeEntry
        ? 'icon-db tools-operation'
        : 'icon-db tools-refresh'
    },
    labelInput () {
      const employee = this.dataSourceEmployee.map[this.data.employeeID]
      return employee && employee.title
    },
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true&orderBy=name')
    }
  }
}
</script>
<style lang="stylus">
.activity-log-item__content-wrap{
  display flex
}
.activity-log-item__content{
  width 100%
  display flex
  align-content flex-start
  flex-direction column
}
.activity-log-item__status{
  color grey
  padding 0 1rem
}
.activity-log-ite__time{
  font 100% 'Roboto', Arial, Tahoma, Geneva, sans-serif
  line-height 35px
  font-size 1.4rem
  font-weight 400
  color #65646c
}
</style>
